module.exports = "<template> <slot></slot> </template> ";